import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import Slider from "react-slick";
import SliderArrow from "src/components/SliderArrow";
import { sHeroSlider } from "src/styles/sHeroSlider.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  children?: any;
  className?: (string | string) | null | undefined;
  dotsVariant?: "light" | "dark";
};

const HeroSlider = ({
  className,
  children,
  dotsVariant = "dark",
  style,
}: Props) => {
  return children?.length > 1 ? (
    <div
      className={composeClassNames([
        sHeroSlider,
        dotsVariant && `dots-${dotsVariant}`,
        className,
        "hero-slider-wrapper",
      ])}
      style={style}
    >
      <Slider
        slidesToShow={1}
        infinite={true}
        speed={500}
        autoplay={true}
        autoplaySpeed={15000}
        dots={true}
        arrows={true}
        nextArrow={<SliderArrow direction={`next`} />}
        prevArrow={<SliderArrow direction={`prev`} />}
      >
        {children}
      </Slider>
    </div>
  ) : (
    children
  );
};

export default HeroSlider;
